export let currentUserInitial = localStorage.getItem('currentUserInitial') || '';
export let currentUserEmail = localStorage.getItem('currentUserEmail') || '';

export const setCurrentUserGlobal = (initial, email) => {
  currentUserInitial = initial;
  currentUserEmail = email;
  if (initial) localStorage.setItem('currentUserInitial', initial);
  if (email) localStorage.setItem('currentUserEmail', email);
};
